import { z } from "zod";
import { employeeCheckSchema } from "../employee-checks/schemas/employeeCheckSchema";
import { schemes } from "../schema-validation";
import { baseEventInput } from "./baseEvent";

export const employeeCheckEvent = baseEventInput.extend({
  source: z.literal("employeechecks"),
  employeeCheckId: schemes.uuid(),
  companyId: schemes.uuid(),
  payload: employeeCheckSchema.partial(),
});

export type EmployeeCheckEvent = z.infer<typeof employeeCheckEvent>;
